import * as React from 'react';
import style from './TypesDropdown.scss';
import { Text, SIZES, WEIGHTS } from '../../../PageElements/Text';
import classnames from 'classnames';
import ChevronDown from 'wix-ui-icons-common/ChevronDown';
import { useDropdown } from '../../../../customHooks/useDropdown';

export interface TypesDropdownOption {
  id: number;
  name: string;
}

interface TypesDropdownProps {
  options: TypesDropdownOption[];
  onSelect: (id: number) => void;
  selectedOptionId: number;
  styleForDropdown: Object;
}

export const TypesDropdown = ({
  options = [],
  onSelect,
  selectedOptionId,
  styleForDropdown,
}: TypesDropdownProps) => {
  const { isOpen, setIsOpen, containerRef, activeOption } = useDropdown({
    options,
    selectedOptionId,
  });

  if (options.length === 0) {
    return null;
  }

  return (
    <div
      ref={containerRef}
      className={style.dropdown}
      onClick={() => setIsOpen((prevState) => !prevState)}
      style={styleForDropdown}
      data-hook="multiple-types-dropdown"
    >
      <span>
        {/*
         // @ts-ignore TODO */}
        <Text
          size={SIZES.small}
          weight={WEIGHTS.normal}
          link
          className={style.activeOption}
          dataHook="multiple-types-dropdown-base"
        >
          {activeOption.name} <ChevronDown />
        </Text>

        <ul
          className={classnames({
            [style.options]: true,
            [style.open]: isOpen,
          })}
        >
          {options.map(({ id, name }) => {
            return (
              <li
                key={id}
                onClick={() => {
                  onSelect(id);
                }}
                className={`${style.option} ${
                  id === selectedOptionId ? style.selected : ''
                }`}
                data-hook={`multiple-types-dropdown-option-${id}`}
              >
                {name}
              </li>
            );
          })}
        </ul>
      </span>
    </div>
  );
};
